import EPLI from "./EPLI";
import { useGetEpliQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";
interface IEPLIProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const EPLIModel = ({ ...props }: IEPLIProps) => {
  const { data, error, loading } = useGetEpliQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <EPLI
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      data={data?.prospect}
    />
  );
};

export default EPLIModel;
